import { UIComponentHandler, UIComponentState, UIDataModel, UIComponentProps, UIComponentImpl } from '../../toolkit/uicomponent';
import { LandingPageAPIModel, LandingPageAPIModelImpl } from './landingpageapimodel';
import { BaseContext, BaseContextImpl } from '../../../utils/basecontext';
import { UIComponentView } from '../../toolkit/uicomponentview';
import { LandingPageViewImpl } from './landingview';
import { UIComponentCSSStyle } from '../../toolkit/uicomponentcss';
import { LandingPageCSSStyleImpl } from './landingcss';
import { APIModelHandler, APIModel } from '../../toolkit/uicomponentapimodel';
import { APIFeatures } from '../../../core/util/apifeatures';
import { Strings } from '../../../utils/resources/strings';
import { AlertType } from '../../toolkit/alert/alerttype';
import { ToneDto, ToneDtoImpl } from '../../../core/dto/tonedto';
import { LanguageConst } from '../../../utils/resources/languageconst';
import { GetPackDetails } from '../popup/getpackdetails';
import { GetTonePriceDetailsDto } from '../../../core/dto/gettoneprice/gettonepricedetailsdto';
import { AESEncryptionDecryption } from '../../../utils/aseencryption';
// import { AESEncryptionDecryption } from '../../../utils/aseencryption';
// import { GenerateOTPAPI } from '../../../core/api/otp/generateotp/generateotpapi';



export interface LandingPageComponentProps extends UIComponentProps
{

}

export interface LandingPageComponentHandler extends UIComponentHandler
{
   onConfirmClick():void;
}

export interface LandingPageComponentState extends UIComponentState
{
   toneDto: ToneDto;
   price: string;
   isNewUser: boolean;
   channel: string;
   isError: boolean;
   packName: string;
   isSuccess:boolean;
}

export class LandingPageComponent extends UIComponentImpl<LandingPageComponentProps, LandingPageComponentState, UIDataModel> 
implements LandingPageComponentHandler
{
    constructor(props: LandingPageComponentProps)
    {
        super(props);

        this.state = {channel: "",packName:"",toneDto: new ToneDtoImpl(), price: "", isNewUser: false, isError: false, isSuccess:false};
        
    }

    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();

        window.addEventListener('error', () =>
        {
            this.setState({isError: true});
           return false;
         });

         window.addEventListener('unhandledrejection',  () => {

            this.setState({isError: true});
         });
    }

    componentDidMount()
    {
        this.decrypt();
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new LandingPageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new LandingPageCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new LandingPageAPIModelImpl(applicationContext, apiModelHandler);
    }

    // componentWillReceiveProps(props: LandingPageComponentProps)
    // {
    //     this.decrypt();
    // }
   
    onConfirmClick(): void 
    {
        console.log("-----msisdn: " + this.props.context.getUserContext().getMsisdn());
        (this.getView() as LandingPageViewImpl).showLoader();
        (this.getAPIModel() as LandingPageAPIModel).getOTP((this.getView() as LandingPageViewImpl).getOTPData());
    }
  
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.SETTINGS)
        {
            (this.getAPIModel() as LandingPageAPIModel).getSearchToneBasedOnId(this.state.toneDto.getId());
        }
        else if(feature === APIFeatures.SEARCH_TONE)
        {
            this.setState({toneDto: (data as ToneDto)[0]});

            (this.getAPIModel() as LandingPageAPIModel).getTonePrice((data as ToneDto[])[0]);
        }
        else if(feature === APIFeatures.GENERATE_OTP)
        {
            (this.getView() as LandingPageViewImpl).dismissLoader();
            this.props.context.getUserContext().setMsisdnB(this.props.context.getUserContext().getMsisdn());
            (this.props.context.getUserContext().setSecToken(""));
            this.props.context.getUserContext().setPackName(this.state.packName);
            this.props.context.getUserContext().setIsnewUser(this.state.isNewUser);
            this.props.context.getUserContext().setChannelId(this.state.channel);
            this.props.context.getUserContext().setUserName(this.props.context.getUserContext().getMsisdn());
            this.props.context.setUserContext(this.props.context.getUserContext());
            //add set chhannelid ----coming from state

            (this.getView() as LandingPageViewImpl).showOTPView();
        }
        else if(feature === APIFeatures.GET_TONE_PRICE)
        {
            //dismiss loader
            (this.getView() as LandingPageViewImpl).dismissLoader();
            let packDetails = this.props.context.getConfigurationSettings().getPropertyBasedOnLanguage("VALIDITY");
            
            let PRICE_TEXT: string = new GetPackDetails(packDetails)
            .getPrice((data as GetTonePriceDetailsDto).getPackName(),
             (data as GetTonePriceDetailsDto).getPrice());

            this.setState({price:PRICE_TEXT, isNewUser: (data as GetTonePriceDetailsDto).getIsNewUser(),
                 packName:(data as GetTonePriceDetailsDto).getPackName()});
        }
        else if(feature === APIFeatures.BUY_TONE)
        {
            (this.getView() as LandingPageViewImpl).showPopup(this.getContext().getResources().getString(Strings.buy_now),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);
            this.setState({isSuccess:true});   
        }
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as LandingPageViewImpl).dismissLoader();
        if(feature === APIFeatures.BUY_TONE)
        {
            (this.getView() as LandingPageViewImpl).showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   
    
        }
        else if(feature === APIFeatures.GET_TONE_PRICE)
        {
            this.setState({isNewUser: true});
        }
        else
        {
            (this.getView() as LandingPageViewImpl).showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   
        }
    }

    private decrypt()
    {
        console.log("inside decrypt document referer :",document.referrer);
       //show loader before setting api
        let params = new URLSearchParams(window.location.search).get("data");
        if(params !== "null" && params !== null && params !== undefined 
        &&  document.referrer !== "" && document.referrer !== null && document.referrer !== undefined)
        {
            let decryptedData = AESEncryptionDecryption.decryptWithAESSha1(params.replace(/ /g,"+"), 
                "5en6G6MezRroT3XKqkdPOg==");
                    //pass key
            let queryParameters = new URLSearchParams(decryptedData);
            let msisdn = queryParameters.get("msisdn");    
            let tuneId = queryParameters.get("tuneId"); 
            let language = queryParameters.get("locale"); 
            let channel = queryParameters.get("channel");

            console.log("decrypteddata: " + decryptedData);
            if(msisdn !== null && msisdn !== undefined && tuneId !== null && tuneId !== undefined
                && language !== null && language !== undefined && channel !== null && channel !== undefined)
            {
                let selectedLangugae = language === "en" ? LanguageConst.FRENCH : LanguageConst.ARABIC;
                this.props.context.getUserContext().setLanguage(selectedLangugae);
                this.props.context.getUserContext().setMsisdn(msisdn);
                this.props.context.getUserContext().setMsisdnB(msisdn);
                this.props.context.getUserContext().setChannelId(channel);
                this.props.context.setUserContext(this.props.context.getUserContext());
                (this.getView() as LandingPageViewImpl).showLoader();
               
                (this.props.context as BaseContextImpl).updateLanguage(3, selectedLangugae, 
                () =>
                {
                    this.state.toneDto.setId(tuneId !== null ? tuneId: "");
                    this.updatePageLayoutBasedonLanguage(this.props.context.getUserContext().getLanguage());
                    
                   this.setState({channel: channel !== null ? channel: "", isError: false, toneDto: this.state.toneDto});
                   (this.getAPIModel() as LandingPageAPIModel).getSettings();
                });
            }
            else
            {
                this.setState({isError: true});
        
            }
        }
        else
        {
            this.setState({isError: true});
        
        }
    }

    private updatePageLayoutBasedonLanguage(selectedLanguage: LanguageConst)
    {
        let rootDiv = document.getElementById("root");

        if(rootDiv !== null)
        {
            if(selectedLanguage === LanguageConst.FRENCH)
            {
                rootDiv.dir = "ltr";
                rootDiv.lang = "en";
                rootDiv.style.fontFamily = this.props.context.getResources().getFontFamily();
            }
            else
            {
                rootDiv.dir = "ltr";
                rootDiv.lang = "my";
                rootDiv.style.fontFamily = this.props.context.getResources().getFontFamily();
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/landingpagecomponent.tsx